import React, { useState } from 'react';
import AAutoComplete from '../../../../../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import AInput from '../../../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import { regex } from '../../../../../../../views/pages/manage/common/constant';
import UploadDocument from '../../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/UploadDocument';
import DocUploadModal from '../../../../../../../views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import styles from "../../../styles.module.scss"

const SubTypeRefundDetailsForm = ({
    refundItemName = "",
    // amountFieldRequired = false,
    form,
    formHandler,
    reasonsDropdownData = [],
    isDisabled,
    maxRefundAmount,
    isLoanCase,
    disableAmountFields
}) => {

    const [uploadDocDialogOpenFor, setUploadDocDialogOpenFor] = useState(null);

    const refundItemFormHandler = (key, value) => formHandler(key, value, refundItemName);

    const refundItemForm = form[refundItemName] ?? {};
    const { reason, remarks, payableToParent = "", payableToVendor = "", parentAttachmentKey, loanAttachmentKey } = refundItemForm;

    const maxParentAmount = maxRefundAmount - payableToVendor;
    const maxVendorAmount = maxRefundAmount - payableToParent;


    return (
        <div style={{borderTop : '2px solid #f5f5f5'}}>
         <div className={styles['refund-item-form-heading'] + " mt-2"}>Add Details</div>   
        <div className={styles['sub-type-refund-details-form']}>



            <AAutoComplete
                label='Refund reason*'
                className='w-20'
                currentValue={reason}
                handleChange={val => refundItemFormHandler("reason", val)}
                items={reasonsDropdownData}
                isMulti={false}
                isDisabled={isDisabled}
            />


            <div className='w-20 '>
                <AInput
                    label="Remarks"
                    value={remarks}
                    handler={val => refundItemFormHandler("remarks", val)}
                    disabled={isDisabled}
                    placeholder={"Enter Remarks"}
                    maxLength={1000}
                />
            </div>

            <div className='w-20 '>
                <AInput
                    label="Payable To Parent"
                    regex={regex.numericDecimal}
                    value={payableToParent}
                    handler={val => (val <= maxParentAmount) && refundItemFormHandler("payableToParent", val)}
                    disabled={isDisabled || disableAmountFields}
                    placeholder={"Enter amount"}
                />
            </div>

            {isLoanCase &&
                <div className='w-20 '>
                    <AInput
                        label="Payable To Third Party"
                        regex={regex.numericDecimal}
                        value={payableToVendor}
                        handler={val => (val <= maxVendorAmount) && refundItemFormHandler("payableToVendor", val)}
                        disabled={isDisabled || disableAmountFields}
                        placeholder={"Enter amount"}
                    />
                </div>
            }

            <div className='w-20'>
                <UploadDocument
                    label={'Parent Attachment' + (+payableToParent > 0 ? "*" : "")}
                    keyFieldName={'parentAttachmentKey'}
                    formHandler={refundItemFormHandler}
                    attachmentKey={parentAttachmentKey}
                    uploadIconClickHandler={() => setUploadDocDialogOpenFor("parentAttachmentKey")}
                    viewOnly={isDisabled}
                    fileName='Parent Attachment'
                />
            </div>

            {isLoanCase &&
                <div className='w-20'>
                    <UploadDocument
                        label={'Loan Attachment' + (+payableToVendor > 0 ? "*" : "")}
                        keyFieldName={'loanAttachmentKey'}
                        formHandler={refundItemFormHandler}
                        attachmentKey={loanAttachmentKey}
                        uploadIconClickHandler={() => setUploadDocDialogOpenFor("loanAttachmentKey")}
                        viewOnly={isDisabled}
                        fileName='Loan Attachment'
                    />
                </div>
            }

            <DocUploadModal
                open={uploadDocDialogOpenFor}
                setOpen={setUploadDocDialogOpenFor}
                acceptedFileTypes={[".pdf"]}
                maxUploadFileSize={5}
                serviceName={'REFUND_SERVICE_ATTACHMENTS'}
                uniqueKeyParameter={"multiTypeRefundAttachment"}
                uploadedFileS3Key={refundItemForm[uploadDocDialogOpenFor]}
                uploadedFileName={"Refund Attachment"}
                modalTitle={"Upload Attachment"}
                saveHandler={(s3Key) => {
                    setUploadDocDialogOpenFor(null);
                    refundItemFormHandler(uploadDocDialogOpenFor, s3Key)
                }}
                key={uploadDocDialogOpenFor}
            />




        </div>
        </div>
    );
}

export default SubTypeRefundDetailsForm;